import { Component, Inject } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TeachingFieldService } from 'src/app/core/services/teaching-field.service';
import { UtilService } from 'src/app/core/services/util.service';
import { TeachingFieldComponent } from '../teaching-field/teaching-field.component';
import { ApproachAssignmentService } from 'src/app/core/services/approach-assignment.service';

@Component({
  selector: 'app-teaching-field-assignment',
  templateUrl: './teaching-field-assignment.component.html',
  styleUrl: './teaching-field-assignment.component.scss'
})
export class TeachingFieldAssignmentComponent {
  action: 'add' | 'edit' = 'add';
  rowData: any = null;

  userForm: FormGroup = new FormGroup({});
  formFields = [
    { name: 'approach', label: 'approach', type: 'text', space: 0 },

    {name: 'teachingFieldId', label: 'Teaching Field', type: 'select', space: 1, validators: [Validators.required],options: []},
    {
      name: 'programPaths', label: 'Program Paths', type: 'select', space: 1, multiple: true,
      options: this.approachAssignmentService.programPaths.map((i: any) => ({ label: i, value: i }))
    },
    { name: 'fee', label: 'Fee ($)', type: 'text', space: 1, validators: [Validators.required] },
  ];
  submitting = false;

  constructor(
    public dialogRef: MatDialogRef<TeachingFieldComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public teachingFieldService: TeachingFieldService,
    public approachAssignmentService: ApproachAssignmentService,
    private utilService: UtilService
  ) {
    this.action = data?.action || 'add';
    this.rowData = data?.data || null;
  }

  ngOnInit() {
    this.getTeachingFieldData();
  }

  getTeachingFieldData() {
    this.teachingFieldService.getTeachingFields().subscribe((res: any) => {
      this.formFields.find((f) => {
        if (f.name === 'teachingFieldId') {
          f.options = res.teachingFields.map((i: any) => ({ label: i.displayName, value: i.id }));
        }
      })
    });
  }

  ngAfterViewInit() {
    if (this.rowData) {
      setTimeout(() => {
        this.userForm.patchValue(this.rowData);
      });
    }
  }

  async submit() {
    if (!this.userForm.valid) return;
    this.submitting = true;
    let payload = this.userForm.getRawValue();
    this.addEdit({...payload, fee:Number(payload.fee)}).subscribe({
      next: () => {
        this.utilService.openToastrCrud('Approach assignment', this.action, 'success');
        this.dialogRef.close(true);
      },
      error: () => {
        this.utilService.openToastrCrud('Approach assignment', this.action, 'error');
        this.submitting = false;
      }
    })
  }

  addEdit(payload: any) {
    if (this.action === 'add') {
      return this.approachAssignmentService.createAssignment(payload)
    } else {
      return this.approachAssignmentService.updateAssignment({ ...payload, active: this.rowData?.active })
    }
  }
}
